import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'single-assessors-relaunch-popup',
  templateUrl: './single-assessors-relaunch-popup.component.html',
  styleUrls: ['./single-assessors-relaunch-popup.component.less',  '../../shared/common.less']
})
export class SingleAssessorsRelaunchPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() isResend = true;
  @Input() isAssessors = false;
  @Input() assessorToRelaunch: string = '';

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }
}
